/** Shared mood vocabulary used by Journal entry editor + Past Entries list. */
export const MOOD_OPTIONS = [
  { value: "radiant", label: "Radiant", emoji: "✨" },
  { value: "peaceful", label: "Peaceful", emoji: "🌸" },
  { value: "energized", label: "Energized", emoji: "⚡" },
  { value: "reflective", label: "Reflective", emoji: "🌙" },
  { value: "tender", label: "Tender", emoji: "💗" },
  { value: "restless", label: "Restless", emoji: "🌊" },
  { value: "grounded", label: "Grounded", emoji: "🌿" },
  { value: "overwhelmed", label: "Overwhelmed", emoji: "🌀" },
];
